import { dataIsBoolean } from "./data";
import { Failure } from "./failure";
//
// listener
//
const messageListener = (meta) => (event) => {
    /**
     * TODO: why do we need this early?
     */
    // if (event.origin !== REACT_APP__URL_SMP_API) {
    //   meta.reject(new Failure(IFailureCode.ROOT__UNKNOWN));
    // }
    const { data } = event;
    if (data.type !== meta.messageType)
        return;
    if (data.error) {
        meta.reject(new Failure("ROOT__UNKNOWN", data.error));
    }
    else if (data.result) {
        meta.resolve(data.result);
    }
    else {
        meta.reject(new Failure("ROOT__UNKNOWN"));
    }
};
//
// getOptions
//
const getOptions = () => {
    const { innerHeight, innerWidth, screen, screenLeft, screenTop } = window;
    const options = {
        center: true,
        directories: false,
        height: 800,
        location: false,
        menubar: false,
        rel: "opener",
        resizable: true,
        scrollbars: true,
        status: false,
        toolbar: false,
        width: 700,
    };
    const screenWidth = innerWidth || screen.width;
    const screenHeight = innerHeight || screen.height;
    options.left = screenWidth / 2 - options.width / 2 + screenLeft;
    options.top = screenHeight / 2 - options.height / 2 + screenTop;
    return options;
};
//
// popupWindowOpen
//
export const popupWindowOpen = (url, messageType, signal, asTab) => new Promise((resolve, reject) => {
    const options = getOptions();
    const stringifiedOptions = stringifyOptions(options);
    const listener = messageListener({
        messageType,
        reject,
        resolve,
    });
    const popupWindow = window.open(typeof url === "string" ? url : "", "_blank", asTab ? undefined : stringifiedOptions);
    if (popupWindow) {
        window.addEventListener("message", listener);
        const windowCloseWatcher = setInterval(() => {
            if (popupWindow.closed) {
                clearInterval(windowCloseWatcher);
                window.removeEventListener("message", listener);
                reject(new Failure("ROOT__UNKNOWN", "POPUP_ABORTED"));
            }
        }, 500);
        if (typeof url === "function") {
            url().then((url) => {
                popupWindow.location.href = url;
            });
        }
        if (signal) {
            signal.addEventListener("abort", () => {
                popupWindow.close();
            });
        }
    }
});
//
// stringifyOptions
//
export const stringifyOptions = (options) => Object.keys(options)
    .map((optionKey) => {
    const value = options[optionKey];
    return (optionKey +
        "=" +
        (dataIsBoolean(value) ? (value ? "yes" : "no") : value));
})
    .join(",");
//# sourceMappingURL=popup.js.map